module.exports = __webpack_public_path__ + "img/yezi2.e66d0493.png";